<template>
  <div>
    <div class="add_tag_view  multiple_item_view_box">
      <h4 class="mr-2">
        License
      </h4>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        v-b-tooltip.hover.top="'Add new license'"
        @click="addInput"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
      </b-button>
    </div>

    <div>
      <div class="row">
        <div
          v-for="(item, index) in licenses"
          :key="index"
          class="col-md-12 mb-2"
        >
          <div class="row">
            <div :class="update ? 'col-md-2' : 'col-md-2'">
              <b-form-group
                label="State"
                label-for="h-state"
                label-cols-md="12"
              >

                <b-form-select
                  id="h-category"
                  v-model="item.state"
                  :options="state_options"
                />

              </b-form-group>
            </div>
            <div :class="update ? 'col-md-3' : 'col-md-4'">
              <b-form-group
                label="License"
                label-for="h-license"
                label-cols-md="12"
              >
                <b-form-input
                  id="license"
                  v-model="item.license"
                  type="text"
                  placeholder="license"
                />
              </b-form-group>
            </div>
            <div :class="update ? 'col-md-4' : 'col-md-4'">
              <b-form-group
                label="License Exp. Date"
                label-for="h-license-exp-date"
                label-cols-md="12"
              >
                <b-form-input
                  id="h-license-exp-date"
                  v-model="item.license_expiration_date"
                  type="date"
                  placeholder=""
                />
              </b-form-group>
            </div>
            <div
              class="d-flex align-items-center"
              :class="update ? 'col-md-3' : 'col-md-2'"
              style="margin-top: 20px"
            >
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                v-b-tooltip.hover.top="'Delete'"
                class="mt-0"
                @click="removeInput(index)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-25"
                />
              </b-button>
              <b-button
                v-if="update === true"
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="ml-2"
                v-b-tooltip.hover.top="'Save'"
                @click="updateInput(index)"
              >
                <feather-icon
                  icon="CheckIcon"
                  class="mr-25"
                />
              </b-button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormInput, BButton, BFormSelect, BFormGroup, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightTransition } from '@core/mixins/ui/transition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormInput,
    BButton,
    BFormSelect,
    BFormGroup,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  mixins: [heightTransition],
  props: {
    update: { type: Boolean, default: false },
    id: { type: Number, default: null },
  },
  data() {
    return {
      user_type: "",
    }
  },
  computed: {
    profile_params() {
      return this.$store.state.businessProfile.admin_param
    },
    licenses: {
      get() {
        return this.$store.state.license.licenses
      },
      set(value) {
        return value
      },
    },
    states() {
      return this.$store.state.state.states
    },
    state_options() {
      return this.states.map(item => {
        const data = { value: item.abbreviation, text: item.abbreviation }
        return data
      })
    },
    userData() {
      return this.$store.state.auth.user
    },
  },
  mounted() {
    // this.getSocialMedia()
    this.user_type = localStorage.getItem('gts_user_type')
  },

  methods: {
    // getSocialMedia() {
    //   return this.$store.dispatch('businessProfile/getSocialMedia')
    // },
    getBusinessProfile() {
      if (this.user_type === 'member') {
        this.$store.dispatch('businessProfile/getProfileVendor', this.profile_params)
      } else {
        this.$store.dispatch('businessProfile/getBusinessProfile', this.profile_params)
      }
    },
    addInput() {
      this.licenses.push({
        license: '',
        license_expiration_date: '',
        state: '',
      })
    },
    removeInput(index) {
      const item = this.licenses[index]
      const dom = this
      if (item.id !== undefined) {
        this.$store.dispatch('license/deleteLicense', item.id)
        setTimeout(() => {
          dom.getBusinessProfile()
        }, 300)
      }
      this.licenses.splice(index, 1)
    },
    updateInput(index) {
      const item = this.licenses[index]
      const dom = this
      if (item.license !== '' && item.licenses !== '') {
        let data

        if (item.id === undefined || item.id === null) {
          data = {
            business_profile_id: this.id,
            licenses: [item],
          }
          this.$store.dispatch('license/addLicenses', data)
          setTimeout(() => {
            dom.getBusinessProfile()
          }, 300)
        } else {
          data = item
          data.business_profile_id = this.id
          this.$store.dispatch('license/updateLicense', data)
          setTimeout(() => {
            dom.getBusinessProfile()
          }, 300)
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fill the form fields before you can save',
            icon: 'AlertTriangleIcon',
            text: '',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
